/**
 * Created by macuser on 9/9/16.
 */

import Backbone from "backbone";
import _ from "underscore";
import moment from "moment";
import $ from "jquery";
export default Backbone.Model.extend({
  initialize: function (attributes, options) {
    Backbone.Model.prototype.initialize.apply(this, arguments);

    this.options = _.defaults({}, options);
    var self = this;

    Object.defineProperty(this, "id", {
      get: function () {
        return self.featureId();
      },
    });
  },

  isNew: function () {
    return this.getFeature() && this.getFeature().isNew();
  },

  sync: function () {
    var result;

    if (!this.getFeature()) {
      result = $.when();
    } else {
      result = this.getFeature().sync.apply(this.getFeature(), arguments);
    }

    return result;
  },

  get: function (attribute) {
    var dt = new Date();
    var tz = -dt.getTimezoneOffset();
    var value = Backbone.Model.prototype.get.apply(this, arguments);
    /*Begin misplaced attribute hotfix. See https://github.com/HBKEngineering/chartroom-client/issues/891*/
    value =
      value || Backbone.Model.prototype.get.apply(this.getFeature(), arguments);
    /*End misplaced attribute hotfix*/
    var result = value;
    var layer = this.getFeature().getLayer();

    if (layer) {
      var field = _.find(layer.getFields(), function (field) {
        return field.id == attribute;
      });
      if (value && field && field.get("type") == "date") {
        var momentValue;

        try {
          momentValue = moment(value);

          if (
            momentValue.hour() +
            momentValue.minute() +
            momentValue.second()
          ) {
            //only do timezone thing if it's not right at midnight, indicating that are just concerned about the date
            momentValue.utcOffset(tz || 0);
            momentValue.local();
          }

          result = momentValue.toISOString();
        } catch (err) {
          result = "";
        }
      }
    }

    return result;
  },

  /**
   * @todo make timezone offset injectable
   * @todo figure out a way to not depend on options.feature.collection.getLayer()...
   * @param key
   * @param val
   * @param options
   * @return {*}
   */
  set: function (key, val, options) {
    if (key == null) return this;

    var attrs,
      finalAttrs = {};

    // Handle both `"key", value` and `{key: value}` -style arguments.
    if (typeof key === "object") {
      attrs = key;
      options = val;
    } else {
      (attrs = {})[key] = val;
    }

    var layer = this.getFeature() ? this.getFeature().getLayer() : null;

    if (layer) {
      var dt = new Date();
      var tz = -dt.getTimezoneOffset();
      var fieldSet = layer.getFields();

      _.each(attrs, function (value, key) {
        var field = _.find(fieldSet, function (field) {
          return field.id == key;
        });
        var result = value;

        if (field && field.get("type") == "date") {
          var momentValue;

          try {
            momentValue = moment(value);

            if (
              momentValue.hour() +
              momentValue.minute() +
              momentValue.second()
            ) {
              //only do timezone thing if it's not right at midnight, indicating that are just concerned about the date
              momentValue.utcOffset(tz || 0);
              momentValue.utc();
            }

            result = momentValue.toISOString();
          } catch (err) {
            result = "";
          }
        }

        finalAttrs[key] = result;
      });
    } else {
      finalAttrs = attrs;
    }

    return Backbone.Model.prototype.set.call(this, finalAttrs, options);
  },

  /**
   * Gets the feature associated with this geometry, if any.
   * @return {app/models/Feature} The associated feature.
   */
  getFeature: function () {
    return this.options ? this.options.feature : null;
  },

  /**
   * Gets the ID of the feature associated with this data, if any.
   * @return {String} The id of the associated feature, if any, or this model's cid, if there is no feature.
   */
  featureId: function () {
    if (this.getFeature()) {
      return this.getFeature().id;
    } else {
      return this.cid;
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/FeatureData.js
// module id = 351
// module chunks = 1